<template>
  <div class="bg1" ref="setH">
    <div class="manageBox">
      <div class="searchBox">
        <ul>
          <li>
            <el-radio-group v-model="search.approvalState" size="small">
              <el-radio-button :label="0">未审核</el-radio-button>
              <el-radio-button :label="1">已通过</el-radio-button>
              <el-radio-button :label="-1">已拒绝</el-radio-button>
            </el-radio-group>
          </li>
          <li>
            <em>基础筛选：</em>
            <!-- 选择学校 -->
            <el-select v-model="search.schoolId" placeholder="选择学校" clearable style="width: 100px" size="small">
              <el-option v-for="item in conditions.xuexiaoList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
            <!-- 选择学段 -->
            <el-select v-model="search.sectionId" placeholder="选择学段" style="width: 100px" size="small" clearable>
              <el-option v-for="item in conditions.xueduanList" :key="item.node" :label="item.text" :value="item.node"></el-option>
            </el-select>
            <!-- 选择年级 -->
            <el-select v-model="search.gradeId" placeholder="选择年级" style="width: 100px" size="small" clearable>
              <el-option v-for="item in conditions.nianjiList" :key="item.node" :label="item.text" :value="item.node"></el-option>
            </el-select>
            <!-- 学科 -->
            <el-select v-model="search.subjectId" placeholder="选择学科" style="width: 100px" size="small" clearable>
              <el-option v-for="item in conditions.xuekeList" :key="item.node" :label="item.text" :value="item.node"></el-option>
            </el-select>
            <el-select v-model="search.versionId" placeholder="选择版本" style="width: 100px" size="small">
              <el-option v-for="item in conditions.banbenList" :key="item.node" :label="item.text" :value="item.node"></el-option>
            </el-select>
            <!-- 册次 -->
            <el-select v-model="search.volumeId" placeholder="选择册次" style="width: 100px" size="small" clearable>
              <el-option v-for="item in conditions.ceciList" :key="item.node" :label="item.text" :value="item.node"></el-option>
            </el-select>
            <!-- 章节 -->
            <!-- <el-select
              v-model="search.chapterId"
              placeholder="选择章节"
              style="width: 100px"
              size="small"
              clearable
            >
              <el-option
                v-for="item in conditions.zhangjieList"
                :key="item.node"
                :label="item.text"
                :value="item.node"
              ></el-option>
            </el-select> -->
          </li>
          <li>
            <em>资源类型：</em>
            <el-select v-model="search.resourceTypeId" placeholder="资源类别" style="width: 100px" size="small" clearable>
              <el-option v-for="item in conditions.ziyuanleibieList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
            <el-select v-model="search.fileType" placeholder="文档类型" style="width: 100px" size="small" clearable>
              <el-option v-for="item in conditions.wendangleixingList" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </li>
          <li>
            <em>上传者：</em>
            <el-input v-model="search.createUserName" placeholder="请输入关键字" size="small" style="width: 180px"></el-input>
          </li>

          <li>
            <em>选择时间：</em>
            <el-date-picker v-model="search.startTime" :picker-options="pickerOptionsStart" value-format="yyyy-MM-dd" size="small" type="date"
                            placeholder="选择日期"></el-date-picker>
            <font style="padding: 0 10px">至</font>
            <el-date-picker v-model="search.endTime" :picker-options="pickerOptionsEnd" value-format="yyyy-MM-dd" size="small" type="date" placeholder="选择日期"
                            @change="endTimeChange">
            </el-date-picker>
            <el-button type="primary" @click="getShenHeLieBiao" size="small">查询</el-button>
            <el-button plain @click="
                search = {
                  approvalState: 0,
                  schoolId: '',
                  sectionId: '',
                  subjectId: '',
                  versionId: '',
                  gradeId: '',
                  volumeId: '',
                  relationDataId: '',
                  dataId: '',
                  chapterId: '',
                  resourceTypeId: '',
                  fileType: '',
                  resourceName: '',
                  firstChapterId: '',
                  secondChapterId: '',
                  thirdChapterId: '',
                  fourthChapterId: '',
                  startTime: '',
                  endTime: '',
                  page: 1,
                  size: 10,
                  total: 0,
                }
              " size="small">重置</el-button>
            <el-button type="primary" v-if="search.approvalState == 0" @click="tongguoORjujue(checkList,1)" size="small">批量通过</el-button>
            <el-button type="danger" v-if="search.approvalState == 0" @click="tongguoORjujue(checkList,-1)" size="small">批量拒绝</el-button>
          </li>
        </ul>
      </div>

      <div class="contentBox">
        <div class="bd ys4" style="min-height: 520px">
          <ul v-if="tableData.length > 0">
            <div class="check_all">
              <el-checkbox v-model="checkAll" @change="onCheckAllChagne">全选</el-checkbox>
            </div>
            <el-checkbox-group v-model="checkList">

              <li v-for="(d, i) in tableData" :key="i">
                <el-checkbox :label="d.resourceId">

                  <div class="icon">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="'#icontbd' + d.fileType"></use>
                    </svg>
                    <!-- <em v-if="d.fileType == 1 || d.fileType == 2 || d.fileType == 3"
                  >- {{ d.filePage }}页 -</em
                > -->
                  </div>
                  <div class="title">
                    <h5 @click="yulan(d, 1)">{{ d.resourceName }}</h5>
                    <span class="catalog">
                      <i class="ka">{{ d.resourceTypeName }}</i>
                      <i v-if="d.versionName">{{ d.versionName }}</i>
                      <i v-if="d.volumeName">/{{ d.volumeName }}</i>
                      <i v-if="d.firstChapterName">/{{ d.firstChapterName }}</i>
                      <i v-if="d.secondChapterName">/{{ d.secondChapterName }}</i>
                      <i v-if="d.thirdChapterName">/{{ d.thirdChapterName }}</i>
                      <i v-if="d.fourthChapterName">/{{ d.fourthChapterName }}</i>
                    </span>
                    <!-- <span class="collection">上传人：{{ d.createUserName }}</span>
                <span class="size"
                  >申请时间：{{ d.createTime.split(" ")[0] }}</span
                > -->
                    <!-- <span class="school">学校：{{ d.schoolName }}</span>
                <span class="author">作者：{{ d.createUserName }}</span> -->
                    <span class="attribute">时间：{{
                    (d.createTime ? d.createTime : d.favoriteDownTime).split(" ")[0]
                  }}</span>
                    <!-- <span class="attribute">下载量：{{ d.downloadNumber }}</span>
                  <span class="attribute">收藏量：{{ d.favoriteNumber }}</span> -->
                    <span class="attribute">大小：{{ unit(d.fileSize) }}</span>
                    <span class="attribute">学校：{{ d.schoolName }}</span>
                    <span class="attribute">作者：{{ d.createUserName ? d.createUserName : d.userName }}</span>
                  </div>
                  <div class="operate">
                    <el-button type="primary" v-if="search.approvalState == 0" @click="tongguoORjujue(d, 1)" size="small" style="width: 80px">通过</el-button>
                    <el-button type="danger" v-if="search.approvalState == 0" @click="tongguoORjujue(d, -1)" size="small" style="width: 80px">拒绝</el-button>
                    <div @click="
                    dialogVisible1 = true;
                    remarkBack = d.reasonViewList;
                  ">
                      <el-badge :value="d.reasonViewList.length" class="item" v-if="d.reasonViewList.length > 0">
                        <el-button size="small">拒绝记录</el-button>
                      </el-badge>
                    </div>
                    <el-button type="text" v-if="search.approvalState == 1" @click="quxiaogongxiang(d)" size="small">取消共享</el-button>
                    <!-- <el-button
                  type="text"
                  v-if="search.approvalState == -1"
                  @click="yulan(d, 1)"
                  size="small"
                  >预览</el-button
                > -->
                  </div>
                </el-checkbox>
              </li>

            </el-checkbox-group>

          </ul>
          <div class="unusual" v-else><span class="pt320">暂无内容</span></div>
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" background layout="total, sizes, prev, pager, next, jumper"
                         :total="search.total" :page-size="search.size"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 、 -->

    <el-dialog title="拒绝原因" :visible.sync="dialogVisible" width="30%">
      <em style="color: #f30; vertical-align: top">*</em>
      <el-input type="textarea" placeholder="请输入备注内容" :autosize="{ minRows: 4 }" v-model="remark" maxlength="50" show-word-limit></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="saveTongguoORjujue(-1)">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="查看拒绝原因" :visible.sync="dialogVisible1" width="30%">
      <ul class="remarkBack">
        <li v-for="(r, i) in remarkBack" :key="'remarkBack' + i">
          <div>审核人：{{ r.approvalUserName }}</div>
          <div>审核时间：{{ r.approvalTime }}</div>
          <div>拒绝原因：{{ r.approvalReason }}</div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="dialogVisible1 = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import yulanmix from "../../mixins/yulan";
export default {
  name: "examine",
  data() {
    return {
      checkList: [],
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.search.endDate) {
            return time.getTime() > new Date(this.search.endDate).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.search.beginDate) {
            return (
              time.getTime() <
              new Date(this.search.beginDate).getTime() - 86400000
            );
          }
        },
      },
      ccc: "审核管理",
      dialogVisible: false,
      dialogVisible1: false,
      remark: "",
      remarkBack: [],
      tabH: 0,
      search: {
        approvalState: 0,
        schoolId: "",
        sectionId: "",
        subjectId: "",
        versionId: "",
        gradeId: "",
        volumeId: "",
        relationDataId: "",
        dataId: "",
        chapterId: "",
        resourceTypeId: "",
        fileType: "",
        resourceName: "",
        firstChapterId: "",
        secondChapterId: "",
        thirdChapterId: "",
        fourthChapterId: "",
        startTime: "",
        endTime: "",
        page: 1,
        size: 10,
        total: 0,
        createUserName: "",
      },
      conditions: {
        xuexiaoList: [],
        xueduanList: [],
        nianjiList: [],
        xuekeList: [],
        banbenList: [],
        ceciList: [],
        zhangjieList: [],
        ziyuanleibieList: [],
        wendangleixingList: [],
      },
      tableData: [],
      pages: {
        pageIndex: 1,
        pageAll: 100,
        pageSize: 10,
      },
      zhancun: {
        id: "",
        rid: "",
        type: "",
      },
      uploadUrl: "",
      previewUrl: "",
      checkAll: "",
    };
  },
  watch: {
    "search.approvalState": {
      handler(v) {
        this.search.resourceName = "";
        this.search.size = 10;
        this.search.page = 1;
        this.getShenHeLieBiao();
      },
    },
    "search.sectionId": {
      handler(v) {
        if (v) {
          this.search.gradeId = "";
          this.search.subjectId = "";
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.nianjiList = [];
          this.conditions.xuekeList = [];
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
          this.getNianJi();
          this.getXueKe();
        } else {
          this.search.gradeId = "";
          this.search.subjectId = "";
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.nianjiList = [];
          this.conditions.xuekeList = [];
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
        }
        this.getShenHeLieBiao();
      },
    },
    "search.subjectId": {
      handler(v) {
        if (v) {
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
          this.getBanben();
        } else {
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
        }
        this.getShenHeLieBiao();
      },
    },
    "search.versionId": {
      handler(v) {
        if (v) {
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
          this.getCeCi();
        } else {
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
        }
        this.getShenHeLieBiao();
      },
    },
    "search.volumeId": {
      handler(v) {
        if (v) {
          this.search.relationDataId = v;
          this.search.dataId = v;
          this.search.chapterId = "";
          this.conditions.zhangjieList = [];
          this.getZhangJie();
        } else {
          this.search.relationDataId = "";
          this.search.dataId = "";
          this.search.chapterId = "";
          this.conditions.zhangjieList = [];
        }
        this.getShenHeLieBiao();
      },
    },
    "search.firstChapterId": {
      handler(v) {
        this.getShenHeLieBiao();
      },
    },
  },
  mixins: [yulanmix],
  mounted() {
    this.$nextTick(() => {
      this.tabH = this.$refs.setH.clientHeight - 230;
    });
    this.getSchoolList();
    this.getXueDuan();
    this.getZiYuanLeiBie();
    this.getWenDangLeixing();
    this.getShenHeLieBiao();
    // this.getResourcesList();
    this.uploadUrl = window.sessionStorage.getItem("uploadUrl");
    this.previewUrl = window.sessionStorage.getItem("previewUrl");
  },
  methods: {
    onCheckAllChagne(val) {
      if (val) {
        this.checkList = this.tableData.map((item) => item.resourceId);
      } else {
        this.checkList = [];
      }
    },
    endTimeChange(val) {
      if (!this.search.startTime) {
        this.$message.warning("请先选择开始时间");
        this.search.endTime = "";
        return;
      }
      if (val) {
        let start = new Date(Date.parse(this.search.startTime));
        let end = new Date(Date.parse(val));
        if (end < start) {
          this.$message.warning("结束时间要大于开始时间");
          this.search.startTime = "";
          this.search.endTime = "";
          return;
        }
      }
    },
    unit(v) {
      let arr = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      while (v > 1024) {
        i++;
        v = Math.floor((v * 100) / 1024) / 100;
      }
      return v + arr[i];
    },
    // 获取学校列表
    getSchoolList() {
      let urlLink = `/common/load/group/school`;
      let param = {};
      this.$ajax.post(urlLink, param).then((res) => {
        this.conditions.xuexiaoList = res;
      });
    },
    // 获取学段
    getXueDuan() {
      let urlLink = `/common/catalog/load/section`;
      this.$ajax.post(urlLink).then((res) => {
        this.conditions.xueduanList = res;
      });
    },
    // 获取年级
    getNianJi() {
      let urlLink = `/common/catalog/load/grade`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        this.conditions.nianjiList = res;
      });
    },
    // 获取学科
    getXueKe() {
      let urlLink = `/common/catalog/load/subject`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        this.conditions.xuekeList = res;
      });
    },
    // 获取版本
    getBanben() {
      let urlLink = `/common/catalog/load/version`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        this.conditions.banbenList = res;
      });
    },
    // 获取册次
    getCeCi() {
      let urlLink = `/common/catalog/load/volume`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        this.conditions.ceciList = res;
      });
    },
    // 获取章节
    getZhangJie() {
      let urlLink = `/common/catalog/load/chapter`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        this.conditions.zhangjieList = res;
      });
    },
    // 获取资源类别
    getZiYuanLeiBie() {
      let urlLink = `/common/load/resource/type`;
      this.$ajax.post(urlLink).then((res) => {
        this.conditions.ziyuanleibieList = res;
      });
    },
    // 获取文档类型
    getWenDangLeixing() {
      let urlLink = `/common/load/file/type`;
      this.$ajax.post(urlLink).then((res) => {
        this.conditions.wendangleixingList = res;
      });
    },
    // 分页页码变动
    handleSizeChange(v) {
      this.search.size = v;
      this.search.page = 1;
      this.getShenHeLieBiao();
    },
    handleCurrentChange(v) {
      this.search.page = v;
      this.getShenHeLieBiao();
    },
    // 查询审核列表
    getShenHeLieBiao() {
      let urlLink = `/server/record/approval/getResourceList`;
      this.$ajax.post(urlLink, this.search).then((res) => {
        this.checkList = [];
        this.tableData = res.list;
        this.search.total = res.total;
      });
    },
    // 通过和拒绝按钮
    tongguoORjujue(obg, type) {
      if (obg instanceof Array) {
        this.zhancun.rid = obg;
      } else {
        this.zhancun.rid = [obg.resourceId];
      }
      if (this.zhancun.rid.length <= 0) {
        this.$message.error("请选择审核文件");
        return;
      }

      // this.zhancun.id = obg.id;
      // this.zhancun.rid = obg.resourceId;
      if (type < 0) {
        this.dialogVisible = true;
        this.remark = "";
      } else {
        this.saveTongguoORjujue(type);
      }
    },
    // 保存通过和拒绝
    saveTongguoORjujue(type) {
      if (type < 0) {
        if (this.remark == "") {
          this.$message({
            message: "请填写拒绝原因",
            type: "warning",
          });
          return;
        }
      }
      let urlLink = `/server/record/approval/setApprovalState`;
      let param = {
        resourceIds: this.zhancun.rid,
        approvalState: type,
        remark: this.remark,
      };
      axios.post(urlLink, param).then((res) => {
        if (res.data.result == "操作成功") {
          this.$message({
            message: res.data.result,
            type: "success",
          });
          this.dialogVisible = false;
          this.getShenHeLieBiao();
        }
      });
    },
    // 取消共享
    quxiaogongxiang(obg) {
      let urlLink = `/server/record/approval/cancelShare`;
      let param = { id: obg.id, resourceId: obg.resourceId };
      this.$ajax.post(urlLink, param).then((res) => {
        if (res == "操作成功") {
          this.$message({
            message: res,
            type: "success",
          });
          this.getShenHeLieBiao();
        }
      });
    },
    // 预览
    // yulan(obg){

    // },
    // 查看
    chakan(obg) {
      let urlLink = `/server/record/approval/showRefuseCauseByResourceId`;
      let param = { resourceId: obg.resourceId };
      this.$ajax.post(urlLink, param).then((res) => {
        this.remarkBack = res;
        if (res != "" || res != null || res != undefined) {
          this.dialogVisible1 = true;
        } else {
          this.$message({
            message: "没有拒绝原因",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.title {
  /* width: 850px !important; */
}
</style>
<style>
.el-checkbox > .el-checkbox__input {
  margin-top: 0 !important;
}
.el-checkbox > .el-checkbox__label {
  display: flex;
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/page/audit/examine.vue